// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Collapse } from 'components/collapse'
import classnames from 'classnames'
import { Space } from 'antd'

export interface IFilterItemProps {
  onChange?: (collapse: boolean) => void
  children: any
  title: string | React.ReactNode
  titleExtra?: React.ReactNode
  defaultCollapsed?: boolean
  className?: string
  headerClassName?: string
}

export interface IFilterItemState {
  icon: React.ReactNode
  contentClassname: string
}

export class FilterItem extends React.Component<IFilterItemProps, IFilterItemState> {
  constructor (props) {
    super(props)
    this.state = {
      icon: this.getIcon(props.defaultCollapsed),
      contentClassname: classnames('filter-item-content', {
        inactive: props.defaultCollapsed
      })
    }
  }

  private getIcon (collapsed: boolean): React.ReactNode {
    return collapsed ? <DownOutlined /> : <UpOutlined />
  }

  private handleChange = (collapsed: boolean) => {
    const { onChange } = this.props
    this.setState(
      {
        icon: this.getIcon(collapsed),
        contentClassname: classnames('filter-item-content', {
          inactive: collapsed
        })
      },
      () => {
        onChange && onChange(collapsed)
      }
    )
  }

  render () {
    const { title, children, titleExtra, defaultCollapsed, headerClassName, className } = this.props
    const { icon, contentClassname } = this.state
    const headerClassnames = classnames('filter-item-header', headerClassName)
    const header = (
      <div className={headerClassnames}>
        <Space size={8}>
          {icon}
          {title}
        </Space>
        {titleExtra}
      </div>
    )
    return (
      <Collapse header={header} onChange={this.handleChange} defaultCollapsed={defaultCollapsed} className={className}>
        <div className={contentClassname}>{children}</div>
      </Collapse>
    )
  }
}
